export const navTopUserLinks = (_loggedInUser) => {
  return [
    {
      to: '/',
      text: 'Home'
    },
    {
      text: 'Profile & Account',
      to: '/account/profile'
    }
  ]
}
